import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { PackingSlipDialogComponent } from './packing-slip-dialog/packing-slip-dialog.component';
import { PackSlipHistoryComponent } from './packing-slip-history/pack-slip-history.component';
import { PackingSlipSearchComponent } from './packing-slip-search/packing-slip-search.component';
import { PackingSlipDetailComponent } from './packing-slip-detail/packing-slip-detail.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'packingslips',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'search', component: PackingSlipSearchComponent, data: { title: 'Packing Slips' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'pack-slip-history', component: PackSlipHistoryComponent, data: { title: 'Packing Slip History' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: ':id',
                        component: PackingSlipDetailComponent,
                        data: { title: 'Packing Slip Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [PackingSlipSearchComponent, PackSlipHistoryComponent, PackingSlipDialogComponent, PackingSlipDetailComponent],
})
export class PackingSlipsModule {}
